import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import PageLayout from "components/LayoutContainers/PageLayout";
import MDBox from "components/MDBox";

export default function UncaughtError({error}) {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <MDBox height="100vh" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <h1>{t("uncaughtError.errorOccurredTitle")}</h1>
        <Button color="primary"><a href="/home">{t("uncaughtError.buttonGoToHomepage")}</a></Button>
        <p>{t("uncaughtError.errorDescription")}</p>
        <pre style={{ fontSize: "12px" }}>{error.message}</pre>
      </MDBox>
    </PageLayout>
  )
}